var _excluded = ["isDisabled", "isReadOnly", "src", "onError", "onClick", "width", "height", "objectFit", "objectPosition", "borderRadius", "aspectRatio"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { FallbackImage } from './assets/FallbackImage';
import { jsx as _jsx } from "react/jsx-runtime";
export var Image = forwardRef((_ref, ref) => {
  var {
    isDisabled,
    isReadOnly,
    src,
    onError,
    onClick,
    width,
    height,
    objectFit = 'cover',
    objectPosition = 'center',
    borderRadius,
    aspectRatio
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [hasError, setHasError] = useState(false);
  var styles = useMultiStyleConfig('Image', {
    objectFit,
    objectPosition,
    borderRadius,
    aspectRatio,
    variant: borderRadius === 'full' ? 'circle' : 'square',
    width: width !== null && width !== void 0 ? width : hasError ? '100%' : 'auto',
    height: height !== null && height !== void 0 ? height : hasError ? '100%' : 'inherit'
  }); // This function is triggered if an error occurs while loading an image

  var imageOnErrorHandler = event => {
    setHasError(true);
    onError === null || onError === void 0 ? void 0 : onError(event);
  };

  var sharedProps = {
    'data-component': 'Image',
    'aria-disabled': isDisabled,
    'data-readonly': isReadOnly,
    onClick: !isDisabled && !isReadOnly ? onClick : undefined,
    ref
  };
  return !hasError ? /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
    as: "img"
  }, sharedProps), props), {}, {
    role: onClick ? 'button' : undefined,
    onError: imageOnErrorHandler,
    __css: styles['image'] // ts-ignore is used due to `src` issues with `<Box/>`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    ,
    src: src
  })) : /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, sharedProps), {}, {
    "data-testid": "fallback-image",
    __css: styles['fallbackImage'],
    children: /*#__PURE__*/_jsx(FallbackImage, {})
  }));
});
Image.displayName = 'Image';
//# sourceMappingURL=Image.js.map